import React, { useEffect, useState, useCallback } from 'react'
import "./AddPortfolio.scss"
import { connect } from "react-redux";
import pencil from "../../../Assets/Images/pencil.svg"
import upload from "../../../Assets/Images/upload-gray.svg"
import { Button, Col, Input, message, Row, Select, Spin, Upload } from 'antd'
import TextArea from 'antd/lib/input/TextArea';
import CoInvestorForm from '../components/CoInvestorForm';
import { dummyRequest, isValidUrl, sectorList } from '../../../Utils/helper';
import { addPortfolioData, uploadPortfolioStartupImage, AddPortfolioApi, addEditPortfolioDetails, CheckStartupNamePortfolio } from '../../../Redux/Actions/PortfolioActions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import debounce from 'lodash/debounce';
const checkValidUrl = new RegExp(
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
);

const AddPortfolio = (props) => {
    const { Option } = Select;
    const history = useHistory()
    const [addPortfolioData, setAddPortfolioData] = useState({})
    const [startupImage, setStartupImage] = useState(null);
    const [startupLogoFile, setStartupLogoFile] = useState(null);
    const [uploading, setUploading] = useState(false)
    const [showValidation, setShowValidation] = useState(false);
    const [errors, setErrors] = useState("");
    const currentYear = new Date().getFullYear();
    const startYear = 2021;

    const years = Array.from(
        { length: currentYear - startYear + 1 },
        (_, i) => startYear + i
    );

    useEffect(() => {
        props.addEditPortfolioDetails({
            co_investors: []
        })
    }, [])

    useEffect(() => {
        setAddPortfolioData(props?.addPortfolioDetail)
    }, [props?.addPortfolioDetail])
    /**
    * Handles the selection of the startup logo image file.
    * @param {File} file - The selected image file for the startup logo.
    */
    const onCompanyLogoSelect = (file) => {
        setStartupImage(URL.createObjectURL(file));
        setStartupLogoFile(file);
    };

    const hasCoInvestorFields = () => {
        return addPortfolioData.co_investors && addPortfolioData.co_investors.some((coInvestor) => coInvestor.co_investor_name || coInvestor.co_investor_image);
    };

    /**
       * Handle the update of the company  image.
       * @param {File} companyLogoFile - The new company logo image file.
       */
    useEffect(() => {
        if (startupLogoFile) {
            let startupLogoData = new FormData();
            startupLogoData.append("file_obj", startupLogoFile);
            startupLogoData.append("is_portfolio", true);
            setUploading(true);
            props
                .uploadPortfolioStartupImage(startupLogoData)
                .then((res) => {
                    setUploading(false);
                    message.success("Startup Image added successfully", 2);
                    setErrors({
                        ...errors,
                        startup_image: ''
                    })
                })
                .catch((errors) => {
                    setUploading(false);
                    message.error("Startup Image Upload Failed", 2);
                });
        }
    }, [startupLogoFile]);

    // Create a debounced function for API call
    const debouncedCheckStartupName = useCallback(
        debounce((name) => {
            if (name && name.trim()) {
                props.CheckStartupNamePortfolio(
                    { startup_name: name },
                    (res) => {
                        // Handle success - startup name is available
                        setErrors(prev => ({
                            ...prev,
                            startup_name: ''
                        }));
                    },
                    (err) => {
                        // Handle error - startup name already exists
                        setErrors(prev => ({
                            ...prev,
                            startup_name: err?.error
                        }));
                    }
                );
            }
        }, 500),
        []
    );

    /**
     * Handles the change in input field values, updates the startup data, and performs input validation.
     * @param {string} field - The name of the field being changed.
     * @param {any} value - The new value for the field.
     */
    const onChangeField = (field, value) => {
        setAddPortfolioData({ ...addPortfolioData, [field]: value });
        onChangeValidation(value, field);
        props.addPortfolioData(field, value);

        if (field === 'startup_name') {
            debouncedCheckStartupName(value);
        }
    };

    /**
     * Handles the change in input field values and updates error messages accordingly.
     * @param {any} value - The value entered in the input field.
     * @param {string} field - The name of the input field.
     */
    const onChangeValidation = (value, field) => {
        let erroObj = { ...errors };
        if (value && errors[field]) {
            erroObj[field] = "";
        }
        if (!value && !errors[field]) {
            erroObj[field] = "This field is required";
        }

        setErrors(erroObj);
    };
    /**
     * Validates the form data and sets error messages accordingly.
     * @returns {boolean} - Returns true if the form data is valid, otherwise false.
     */
    const validateForm = () => {
        let isValid = true;
        let errObj = {};
        if (!addPortfolioData.startup_image) {
            errObj.startup_image = "Startup Image is required";
            isValid = false;
        }
        if (!addPortfolioData?.startup_name) {
            errObj.startup_name = "This field is required";
            isValid = false;
        }
        if (!addPortfolioData?.sector) {
            errObj.sector = "This field is required";
            isValid = false;
        }
        if (!addPortfolioData?.investment_year) {
            errObj.investment_year = "This field is required";
            isValid = false;
        }
        if (!addPortfolioData?.status) {
            errObj.status = "This field is required";
            isValid = false;
        }

        if (errors.startup_name) {
            errObj.startup_name = errors.startup_name;
            isValid = false;
        }
        if (errors.sector) {
            errObj.sector = errors.sector;
            isValid = false;
        }
        if (errors.investment_year) {
            errObj.investment_year = errors.investment_year;
            isValid = false;
        }
        if (errors.status) {
            errObj.status = errors.status;
            isValid = false;
        }
        if (!addPortfolioData?.description) {
            errObj.description = "This field is required";
            isValid = false;
        }
        if (hasCoInvestorFields()) {
            for (let i = 0; i < addPortfolioData.co_investors?.length; i++) {
                const coInvestor = addPortfolioData.co_investors[i];
                if (!coInvestor.co_investor_image) {
                    errObj[`co_investor_${i}_image`] = "Co-Investor Logo is required";
                    isValid = false;
                }
                if (!coInvestor.co_investor_name) {
                    errObj[`co_investor_${i}_name`] = "Co-Investor Name is required";
                    isValid = false;
                }

            }
        }
        let website = addPortfolioData?.startup_website?.trim();
        const isNA = website?.toLowerCase() === "n/a";

        if (!website) {
            errObj.startup_website = "This field is required";
            isValid = false;
        }
        // else if (!isNA && !checkValidUrl.test(website)) {
        else if (!isNA && !isValidUrl(website)) {
            errObj.startup_website = "Please enter a valid URL or N/A.";
            isValid = false;
        }

        // If user entered any form of N/A → store it normalized
        if (isNA) {
            website = "n/a";
        }
        addPortfolioData.startup_website = website;
        setErrors(errObj);
        if (!isValid) {
            setShowValidation(true);
        } else {
            setShowValidation(false);
        }
        return isValid;
    }

    const onSaveStartup = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateForm()) {
            setUploading(true);
            props.AddPortfolioApi(addPortfolioData,
                res => {
                    message.success(res.data.message, 2);
                    setUploading(false);
                    history?.push("/portfolio");
                }, err => {
                    setUploading(false);
                    message.error(err || "Portfolio Adding Failed", 2);
                })
        }
    }

    // Clean up debounce on unmount
    useEffect(() => {
        return () => {
            debouncedCheckStartupName.cancel();
        };
    }, []);

    return (
        <div className="add-portfolio-container">
            <div className="top-portfolio">
                <h6>Portfolio</h6>
                <div className="portfolio-right">
                    <Button className="save-btn"
                        onClick={onSaveStartup}
                    >
                        Save
                    </Button>
                </div>
            </div>
            <Spin spinning={uploading}>
                <div className="startup-edit-wrap">
                    <div className='inner-section'>
                        <Row gutter={24}>
                            <Col span={24}>
                                {(startupImage || addPortfolioData.startup_image) ?
                                    <>
                                        <div className="logo">
                                            {startupImage ? (
                                                <img
                                                    src={startupImage}
                                                    alt="Company Logo"
                                                    className="logo-img"
                                                />
                                            ) : (
                                                addPortfolioData.startup_image && <img
                                                    src={addPortfolioData?.startup_image}
                                                    alt="Company Logo"
                                                    className="logo-img"
                                                />
                                            )}
                                            {(startupImage || addPortfolioData.startup_image) && <Upload
                                                customRequest={dummyRequest}
                                                onChange={(file) =>
                                                    onCompanyLogoSelect(file.file.originFileObj)
                                                }
                                                accept="image/png,image/jpeg,image/jpg"
                                            >
                                                <div className="edit-logo">
                                                    <img src={pencil} alt="Edit" />
                                                </div>
                                            </Upload>}

                                        </div>
                                        <p className='quickNote'>Recommended dimensions are 1024 x 1024 pixels
                                            for optimal display</p>
                                    </> : <div className='upload-companyLogo'>
                                        <Upload
                                            customRequest={dummyRequest}
                                            onChange={(file) =>
                                                onCompanyLogoSelect(file.file.originFileObj)
                                            }
                                            accept="image/png,image/jpeg,image/jpg"
                                        >
                                            <div className='upload-innerSection'>
                                                <img src={upload} alt="upload" />
                                                <h1>Upload Startup Image</h1>
                                                <p>Recommended dimensions are 1024 x 1024 pixels for optimal display</p>
                                            </div>
                                        </Upload>
                                    </div>
                                }

                                {showValidation && (
                                    <span className="validation-msg">
                                        {errors["startup_image"]}
                                    </span>
                                )}
                            </Col>
                            <Col span={24}>
                                <div className="field-box">
                                    <label>Startup Name</label>
                                    <Input
                                        maxLength={50}
                                        value={addPortfolioData?.startup_name}
                                        placeholder={"Startup name"}
                                        className="inputs-box"
                                        onChange={(e) =>
                                            onChangeField(
                                                "startup_name",
                                                e.target.value?.trimStart()
                                            )
                                        }
                                    />
                                    {(showValidation || errors["startup_name"]) && (
                                        <span className="validation-msg">
                                            {errors["startup_name"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="field-box">
                                    <label>Startup Website</label>
                                    <Input
                                        maxLength={50}
                                        value={addPortfolioData?.startup_website}
                                        placeholder={"Startup Website"}
                                        className="inputs-box"
                                        onChange={(e) =>
                                            onChangeField(
                                                "startup_website",
                                                e.target.value?.trimStart()
                                            )
                                        }
                                    />
                                    {(showValidation || errors["startup_website"]) && (
                                        <span className="validation-msg">
                                            {errors["startup_website"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="dropdown-box">
                                    <label>Sector</label>
                                    <div>
                                        <Select
                                            placeholder="Startup Sector"
                                            className="selector-box"
                                            value={addPortfolioData?.sector}
                                            onChange={(e) =>
                                                onChangeField("sector", e)
                                            }
                                        >
                                            {sectorList.map((item) => (
                                                <Option
                                                    key={item}
                                                    value={item}
                                                // className="round-option"
                                                >
                                                    {item}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    {(showValidation || errors["sector"]) && (
                                        <span className="validation-msg">
                                            {errors["sector"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="field-box">
                                    <label>Investment Year</label>
                                    <div>
                                        <Select
                                            placeholder="Select Year"
                                            className="selector-box"
                                            value={addPortfolioData?.investment_year}
                                            onChange={(e) =>
                                                onChangeField("investment_year", e)
                                            }
                                        >
                                            {years.map((item) => (
                                                <Option
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    {(showValidation || errors["investment_year"]) && (
                                        <span className="validation-msg">
                                            {errors["investment_year"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                            <Col span={6}>
                                <div className="field-box">
                                    <label>Status</label>
                                    <div>
                                        <Select
                                            placeholder="Select Status"
                                            className="selector-box"
                                            value={addPortfolioData?.status}
                                            onChange={(e) =>
                                                onChangeField("status", e)
                                            }
                                        >
                                            {["Active", "Exited"].map((item) => (
                                                <Option
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    {(showValidation || errors["status"]) && (
                                        <span className="validation-msg">
                                            {errors["status"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="description-box">
                                    <label>Description</label>
                                    <TextArea
                                        rows={10}
                                        bordered={0}
                                        spellCheck={false}
                                        placeholder={"Description"}
                                        value={addPortfolioData?.description}
                                        className="text-area-box"
                                        onChange={(e) => {
                                            const cleaned = e.target.value.replace(/&amp;/g, "&");
                                            onChangeField(
                                                "description",
                                                cleaned
                                            )
                                        }
                                        }
                                    />{" "}
                                    {showValidation && (
                                        <span className="validation-msg">
                                            {errors["description"]}
                                        </span>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='inner-section2'>
                        <h2>Add Co-Investor</h2>
                        <CoInvestorForm addPortfolioData={addPortfolioData} setUploading={setUploading} errors={errors} setErrors={setErrors} />
                    </div>
                </div>
            </Spin>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        addPortfolioDetail: state.Portfolio.portfolioDetails,
        loading: state.Portfolio.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadPortfolioStartupImage: (data) =>
            dispatch(uploadPortfolioStartupImage(data)),
        addPortfolioData: (field, value) =>
            dispatch(addPortfolioData(field, value)),
        AddPortfolioApi: (data, onSuccess, onError) =>
            dispatch(AddPortfolioApi(data, onSuccess, onError)),
        addEditPortfolioDetails: (data) => dispatch(addEditPortfolioDetails(data)),
        CheckStartupNamePortfolio: (data, onSuccess, onError) => dispatch(CheckStartupNamePortfolio(data, onSuccess, onError)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPortfolio);